// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"8a90fc30","381":"30601ef0","453":"c06b7505"}[chunkId] + ".chunk.js";
};